import React from 'react';

const BSLAPopupItemComponent: React.FC<{ label: string; value: string }> = (props) => {
    return (
        <div className="mb-1">
            {props.label}: <strong>{props.value}</strong>
        </div>
    );
};

export default BSLAPopupItemComponent;
